// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PEyeOutlinedSvg from "@fishx/icons-svg/es/asn/PEyeOutlined";
import FishxIcon from '../components/FishxIcon';

var PEyeOutlined = function PEyeOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PEyeOutlinedSvg
  }));
};

PEyeOutlined.displayName = 'PEyeOutlined';
export default React.forwardRef(PEyeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PEyeOutlined.js
// module id = 3367
// module chunks = 0